"use client";

import { SessionProvider } from "next-auth/react";
import { ApolloProvider } from "@apollo/client";
import Script from "next/script";
import { ReactNode } from "react";
import { getClient } from "@/lib/apollo";
import { NEXT_PUBLIC_GOOGLE_PLACES_API_KEY } from "@/config/env";
import { markGoogleMapsLoaded } from "@/lib/google-maps";
import { UserProvider } from "@/contexts/UserContext";
import { ToastProvider } from "./ToastProvider";
import { NuqsAdapter } from "nuqs/adapters/next/app";

const FALLBACK_API_KEY = "AIzaSyDMkvm4xOsCbVxhJjhkEfv9qO0bfvTGlQ8";
const API_KEY = NEXT_PUBLIC_GOOGLE_PLACES_API_KEY || FALLBACK_API_KEY;

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  const client = getClient();

  return (
    <SessionProvider>
      <ApolloProvider client={client}>
        <UserProvider autoFetch={true} refetchInterval={5 * 60 * 1000}>
          <ToastProvider>
            <NuqsAdapter>{children}</NuqsAdapter>
          </ToastProvider>
        </UserProvider>
      </ApolloProvider>
      <Script
        src={`https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places&loading=async`}
        onLoad={() => markGoogleMapsLoaded()}
        strategy="afterInteractive"
      />
      <Script
        src="https://accounts.google.com/gsi/client"
        strategy="afterInteractive"
      />
    </SessionProvider>
  );
}
